// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommend[data-v-6c3b3f54]{width:100px}.recommend-title[data-v-6c3b3f54]{height:28px;font-size:18px;font-weight:500;color:#14171c;line-height:28px}.recommend-cover[data-v-6c3b3f54]{border-radius:8px;margin-top:12px;cursor:pointer}.is-fixed[data-v-6c3b3f54]{position:fixed;top:100px}", ""]);
// Exports
module.exports = exports;
